// Use CHAR for quotes/backslashes so labels stay text across formula engines.
// In particular, a trailing backslash must never escape a literal's closing quote.
export function buildGroupNameFormula(value: any, orderNo: any, previousRow: number): string {
    const text = ['string', 'number', 'boolean'].includes(typeof value) ? String(value) : '';
    const name = text.split(/(["\\])/).map((part, index) => {
        if (index % 2) {
            return part === '"' ? 'CHAR(34)' : 'CHAR(92)';
        }
        return '"' + part + '"';
    }).join('&');
    const order = typeof orderNo === 'number' || typeof orderNo === 'string' ? String(orderNo) : '';
    // Only numeric (including hierarchical) order numbers may enter COUNTIF criteria.
    const validOrder = order === order.trim() && /^[0-9]+(?:\.[0-9]+)*$/.test(order);
    const count = Number.isSafeInteger(previousRow) && previousRow > 0 && validOrder
        ? 'COUNTIF(A1:A' + previousRow + '; "' + order + '")' : '0';
    return '=' + name + '&IF(' + count + '>0;" ("&' + count + '&")";"")';
}
